import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

const i18nextOptions = {
  backend: { loadPath: "../i18n/{{lng}}/{{ns}}.json" },
  debug: false,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
};
export const isI18nInitialized = i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(i18nextOptions);

export default i18n;
